import * as React from "react"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import HelpIcon from "@mui/icons-material/Help"
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from "@mui/material/Tooltip"

import { Box, Checkbox, TextField } from "@mui/material"
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import { update_cart, useTrackedReservationCart } from "./CheckoutState"
import { moneyFormat } from "../Utils"

export default function CartItem({ item, reservation_length, reserveStartDate, reserveEndDate }) {
    const [reservationCart, setReservationCart] = useTrackedReservationCart();
    // Used to make sure this entity uses reservationCart to ensure rerender after updates
    const my_item = reservationCart.cart.findIndex((cart_item) => item.id === cart_item.id)
    const my_fees = Object.keys(reservationCart.fees_data[my_item] || {}).flat().toString()

    const updateFeeOptional = (item_id, fee_id, value) => {
        let myReservationCart = Object.assign({}, reservationCart)
        myReservationCart.random_state_jiggler = Date.now()
        if (myReservationCart.fees_data[item_id] === undefined) {
            myReservationCart.fees_data[item_id] = { [fee_id]: { optional_selection: false } }
        }
        myReservationCart.fees_data[item_id][fee_id]["optional_selection"] = !myReservationCart.fees_data[item_id][fee_id]["optional_selection"]
        console.log(myReservationCart.fees_data)
        update_cart({ ...myReservationCart }, reservation_length, reserveStartDate, reserveEndDate, setReservationCart)
    }

    const updateQuantity = (item_id, quantity) => {
        const inCart = reservationCart.cart.findIndex((item) => item_id === item.id)
        if (inCart !== -1) {
            let myReservationCart = Object.assign({}, reservationCart)
            myReservationCart.random_state_jiggler = Date.now()
            myReservationCart.cart[inCart].quantity = quantity
            update_cart({ ...myReservationCart }, reservation_length, reserveStartDate, reserveEndDate, setReservationCart)
        }
    }

    const removeItem = (item_id) => {
        const inCart = reservationCart.cart.findIndex((item) => item_id === item.id)
        if (inCart !== -1) {
            let myCart = [...reservationCart.cart]
            myCart.splice(inCart, 1)
            let myFeesData = { ...reservationCart.fees_data }
            delete myFeesData[inCart]
            update_cart({ ...reservationCart, cart: myCart, fees_data: myFeesData }, reservation_length, reserveStartDate, reserveEndDate, setReservationCart)
        }
    }

    return (
        <Box key={`${my_item}-${my_fees}`} sx={{ border: 1, m: 1, p: 1, borderColor: item.available ? 'rgba(0,0,0,0.87)' : 'rgb(211,47,47)' }}>
            {!item.available &&
                <Box display="flex">
                    <InfoIcon color="error" /> <Box sx={{ pl: 1, color: 'rgb(211,47,47)' }}><span><b>Not Available</b></span></Box>
                </Box>
            }
            <Grid container>
                <Grid xs>
                    <span><b>{item.unique_name}</b></span>
                </Grid>
                <Grid xs="auto">
                    <Button onClick={() => removeItem(item.id)}>Remove <RemoveShoppingCartIcon /></Button>
                </Grid>
            </Grid>
            <p style={{ marginLeft: 16, marginTop: 0, marginBottom: 10 }}>Required:</p>
            {item.bulk_type &&
                <Box sx={{ ml: '32px' }}>
                    <TextField
                        key={`${item.id}-${item.quantity}`}
                        sx={{ mt: 0 }}
                        autoFocus
                        margin="dense"
                        id="quantity"
                        label="Quantity"
                        type="tel"
                        fullWidth
                        variant="standard"
                        value={item.quantity}
                        onChange={(event) => updateQuantity(item.id, Math.min(Math.max(parseInt(event.target.value), 1), item.total_quantity))}
                        error={item.quantity > item.max_available}
                        helperText={item.quantity > item.max_available ? `Quantity not available (max #${item.max_available})` : ""}
                    />
                </Box>
            }
            <Grid container sx={{ pl: '32px' }}>
                <Grid xs>
                    <span>Rental Rate
                        <Tooltip title={item.calculated_rate_visualization}>
                            <HelpIcon sx={{ fontSize: 'inherit' }} />
                        </Tooltip>
                    </span>
                </Grid>
                <Grid xs="auto">
                    <span>${moneyFormat(item.calculated_rate)}</span>
                </Grid>
            </Grid>
            {item.rental_type.fees.filter((item) => item.optional !== true).map((fee) => {
                return (<Grid container sx={{ pl: '32px' }} key={`${item.id}-${fee.id}-fee`}>
                    <Grid xs>
                        {fee.fee_type === 'PERCENTAGE' && <span>{fee.name} ({fee.calculation}%)</span>}
                        {fee.fee_type === 'FLAT_RATE' && <span>{fee.name}</span>}
                        {fee.fee_type === 'FLAT_RATE_PER_ITEM' && <span>{`${fee.name} ($${moneyFormat(fee.calculation)}/item)`}</span>}
                    </Grid>
                    <Grid xs="auto">
                        {fee.fee_type === 'PERCENTAGE' && <span>${moneyFormat(item.calculated_rate * (fee.calculation / 100))}</span>}
                        {fee.fee_type === 'FLAT_RATE' && <span>${moneyFormat(fee.calculation)}</span>}
                        {fee.fee_type === 'FLAT_RATE_PER_ITEM' && <span>${moneyFormat(fee.calculation * item.quantity)}</span>}
                    </Grid>
                </Grid>)
            })}
            <Grid container sx={{ pl: '32px' }}>
                <Grid xs>
                    <span>Taxes ({item.location.tax_rate || 0}%)</span>
                </Grid>
                <Grid xs="auto">
                    <span>${moneyFormat(item.calculated_tax)}</span>
                </Grid>
            </Grid>
            {item.rental_type.fees.filter((item) => item.optional === true).length > 0 && <p style={{ marginLeft: 16 }}>Optional:</p>}
            {item.rental_type.fees.filter((item) => item.optional === true).map((fee) => {
                return (<Grid container sx={{ pl: '32px' }} key={`${item.id}-${fee.id}-fee`}>
                    <Grid xs="auto">
                        <Checkbox
                            sx={{ pt: 0, pb: 0 }}
                            checked={reservationCart.fees_data[item.id]?.[fee.id]?.optional_selection || false}
                            onChange={(event) => updateFeeOptional(item.id, fee.id, event.target.checked)}
                        />
                    </Grid>
                    <Grid xs>
                        {fee.fee_type === 'PERCENTAGE' && <span>{fee.name} ({fee.calculation}%)</span>}
                        {fee.fee_type === 'FLAT_RATE' && <span>{fee.name}</span>}
                        {fee.fee_type === 'FLAT_RATE_PER_ITEM' && <span>{`${fee.name} ($${moneyFormat(fee.calculation)}/item)`}</span>}
                    </Grid>
                    <Grid xs="auto">
                        {fee.fee_type === 'PERCENTAGE' && <span>${moneyFormat(item.calculated_rate * (fee.calculation / 100))}</span>}
                        {fee.fee_type === 'FLAT_RATE' && <span>${moneyFormat(fee.calculation)}</span>}
                        {fee.fee_type === 'FLAT_RATE_PER_ITEM' && <span>${moneyFormat(fee.calculation * item.quantity)}</span>}
                    </Grid>
                </Grid>)
            })}
            <hr></hr>
            <Grid container columnSpacing={3} justifyContent="flex-end" sx={{ textAlign: 'right', fontWeight: 'bold' }}>
                <Grid xs>
                    <Grid container direction="column">
                        <Grid xs="auto">
                            <span>Total:</span>
                        </Grid>
                        <Grid xs="auto">
                            {item.rental_type.deposit_type === 'PERCENTAGE' && <span>Deposit ({item.rental_type.deposit_calculation}%{item.rental_type.deposit_include_fees ? " w/fees" : ""}):</span>}
                            {item.rental_type.deposit_type === 'FLAT_RATE' && <span>Deposit:</span>}
                            {item.rental_type.deposit_type === 'FLAT_RATE_PER_ITEM' && <span>{`Deposit ($${moneyFormat(item.rental_type.deposit_calculation)}/item):`}</span>}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs="auto">
                    <Grid container direction="column">
                        <Grid xs="auto">
                            <span>${moneyFormat(item.calculated_posttax_total)}</span>
                        </Grid>
                        <Grid xs="auto">
                            <span>${moneyFormat(item.calculated_deposit)}</span>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}